import React from 'react'
import Navbar from '../components/Navbar';
import ProjectCards from '../components/ProjectCards';


const Project = () => {
  return (
    <div>
      <Navbar/>
      <ProjectCards/>
    </div>
  )
}

export default Project
